import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

const Container = styled.div`
    display: inline-block;
    width: ${(props) => `${props.width}%`};
    height: ${(props) => `${props.theme.space[props.height]}px`};
    background: ${(props) => `${props.theme.colors['surface-neutral-100']}`};
    overflow: hidden;
    border-radius: 4px;

    ${(props) =>
        props.shape === 'circle' &&
        css`
            border-radius: ${(props) => `${props.theme.space[props.height]}px`};
        `}

    &::after {
        content: ' ';
        display: block;
        width: 100%;
        height: 100%;
        box-shadow: #e8ebee20 0px 0px 1px;
        background-image: linear-gradient(
            110deg,
            ${(props) => `${props.theme.colors['surface-neutral-100']}`} 0%,
            ${(props) => `${props.theme.colors['surface-neutral-150']}`} 50%,
            ${(props) => `${props.theme.colors['surface-neutral-100']}`} 100%
        );
        animation: progress 1.6s ease-in-out infinite;

        @keyframes progress {
            0% {
                transform: translateX(-100%);
            }
            100% {
                transform: translateX(100%);
            }
        }
    }
`;

const Ghost = ({ width = 100, height = 'base', shape = 'square' }) => {
    return <Container width={width} height={height} shape={shape} />;
};

Ghost.propTypes = {
    shape: PropTypes.oneOf(['square', 'circle']),
    width: PropTypes.number,
    height: PropTypes.oneOf(['none', 'xxs', 'xs', 'small', 'median', 'base', 'medium', 'regular', 'large', 'xl', 'xxl']),
};

export default Ghost;
